/**
 * Shared HTML builders for lesson chat messages (live room + post-lesson inserts).
 */

/**
 * Strip the host from lesson-file download URLs so they resolve on whichever
 * portal (Mypage or NetEnglish) the participant is logged into.
 */
export function normalizeLessonFileUrl(url) {
    if (!url || typeof url !== 'string') {
        return url;
    }

    const trimmed = url.trim();
    if (trimmed.startsWith('/lesson-file/download')) {
        return trimmed;
    }

    try {
        const parsed = new URL(trimmed, window.location.origin);
        if (parsed.pathname === '/lesson-file/download') {
            return parsed.pathname + parsed.search;
        }
    } catch (e) {
        // not a valid URL — return as-is
    }

    return trimmed;
}

export function buildFileChatMessageHtml(url, fileName) {
    const portalUrl = normalizeLessonFileUrl(url);
    const ext = (fileName.split('.').pop() || '').toLowerCase();
    const safeUrl = String(portalUrl).replace(/"/g, '&quot;');
    const safeName = String(fileName).replace(/</g, '&lt;').replace(/>/g, '&gt;');
    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) {
        return `<a class="img_preview" target="_blank" href="${safeUrl}"><img src="${safeUrl}" class="img_preview" alt="${safeName}"></a>`;
    }
    return `<a class="img_preview" target="_blank" href="${safeUrl}"><i class="fas fa-file-alt"></i></a> <div><a class="img_link" target="_blank" href="${safeUrl}">${safeName}</a></div>`;
}

export function escapeChatHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

export function buildTextChatMessageHtml(text) {
    return escapeChatHtml(text).replace(/\r?\n/g, '<br>');
}

export function combineChatMessageParts(textHtml, fileHtml) {
    const parts = [];
    if (textHtml && textHtml.trim()) {
        parts.push(textHtml);
    }
    if (fileHtml && fileHtml.trim()) {
        parts.push(fileHtml);
    }
    return parts.join('<br>');
}
